// =====================================================================
// PLENARIUM:TV_CERIMONIAL -- abertura e encerramento no Painel da TV
//  - Quando a sessao comeca: tela de boas-vindas (brasao, saudacao,
//    camara, sessao, data e hora) por alguns segundos.
//  - Quando a sessao e encerrada: tela de agradecimento (resumo das
//    materias e a proxima sessao, se ja estiver agendada).
// So reage a MUDANCA vista com a TV ligada (abrir ou recarregar a TV no
// meio da sessao nao repete a abertura). Para testar: ?cerimonial=abertura
// ou ?cerimonial=encerramento no endereco da TV.
// Feito com HTML simples por cima da tela: nao mexe no resto do painel.
// =====================================================================
import { useEffect, useLayoutEffect, useRef } from 'react';
import axios from 'axios';

const ID = 'pl-cerimonial';
const DURACAO_ABERTURA = 14000;
const DURACAO_ENCERRAMENTO = 180000;
const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
const DIAS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
const p2 = (n) => String(n).padStart(2, '0');
const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const hoje = () => { const d = new Date(); return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`; };
const agoraHM = () => { const d = new Date(); return `${p2(d.getHours())}h${p2(d.getMinutes())}`; };
const saudacao = () => { const h = new Date().getHours(); return h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite'; };
// datas das sessoes ficam gravadas como horario local "em UTC" (mesma regra do roteiro)
const dataSessao = (d) => { const x = new Date(d); return `${DIAS[x.getUTCDay()]}, ${x.getUTCDate()} de ${MESES[x.getUTCMonth()]}, às ${p2(x.getUTCHours())}h${p2(x.getUTCMinutes())}`; };
const tituloLimpo = (t) => String(t || '').replace(/\s+/g, ' ').trim();

const CSS = `
#${ID} { position: fixed; inset: 0; z-index: 99999; overflow: hidden; color: #fff; font-family: 'DM Sans', 'Inter', system-ui, sans-serif;
  background: radial-gradient(ellipse 120% 90% at 50% 30%, #163a6b 0%, #0b1f3d 42%, #050c19 100%);
  display: flex; align-items: center; justify-content: center; text-align: center; opacity: 0; transition: opacity 1.2s ease; cursor: default; }
#${ID}.on { opacity: 1; }
#${ID}.saindo { opacity: 0; }
#${ID} .plc-orb { position: absolute; border-radius: 50%; filter: blur(9vh); opacity: .55; pointer-events: none; }
#${ID} .plc-orb.a { width: 60vh; height: 60vh; left: -12vh; top: -10vh; background: #1d4ed8; animation: plcFlutua 16s ease-in-out infinite; }
#${ID} .plc-orb.b { width: 55vh; height: 55vh; right: -14vh; bottom: -16vh; background: #b8862b; opacity: .28; animation: plcFlutua 19s ease-in-out infinite reverse; }
#${ID} .plc-brilho { position: absolute; inset: -50%; background: linear-gradient(115deg, transparent 42%, rgba(255,255,255,.07) 50%, transparent 58%); animation: plcVarre 7s ease-in-out infinite; pointer-events: none; }
#${ID} .plc-moldura { position: absolute; inset: 3.2vh; border: .18vh solid rgba(245,215,142,.22); border-radius: 2.4vh; pointer-events: none; }
#${ID} .plc-moldura::before, #${ID} .plc-moldura::after { content: ''; position: absolute; width: 9vh; height: 9vh; border-color: #e9c46a; border-style: solid; opacity: .8; }
#${ID} .plc-moldura::before { left: -.18vh; top: -.18vh; border-width: .45vh 0 0 .45vh; border-radius: 2.4vh 0 0 0; }
#${ID} .plc-moldura::after { right: -.18vh; bottom: -.18vh; border-width: 0 .45vh .45vh 0; border-radius: 0 0 2.4vh 0; }
#${ID} .plc-conteudo { position: relative; max-width: 82vw; display: flex; flex-direction: column; align-items: center; }
#${ID} .plc-brasao { height: 19vh; max-width: 30vh; object-fit: contain; filter: drop-shadow(0 0 3vh rgba(245,215,142,.35)); animation: plcBrasao 1.6s cubic-bezier(.2,.8,.2,1) both; }
#${ID} .plc-sobre { margin-top: 2.6vh; font-size: 1.9vh; font-weight: 800; letter-spacing: .9vh; text-transform: uppercase; color: #f5d78e; }
#${ID} .plc-grande { margin-top: 1.4vh; font-size: 10.5vh; font-weight: 900; line-height: 1; letter-spacing: -.15vh;
  background: linear-gradient(90deg, #ffffff 0%, #f5d78e 45%, #ffffff 100%); background-size: 200% 100%; -webkit-background-clip: text; background-clip: text; color: transparent; animation: plcOuro 6s linear infinite; }
#${ID} .plc-medio { margin-top: 1.6vh; font-size: 4.2vh; font-weight: 800; }
#${ID} .plc-linha { width: 0; height: .35vh; margin: 3vh auto 2.6vh; border-radius: 99px; background: linear-gradient(90deg, transparent, #e9c46a, transparent); animation: plcLinha 1.4s .9s ease forwards; }
#${ID} .plc-sessao { font-size: 3vh; font-weight: 700; color: #dbeafe; max-width: 70vw; line-height: 1.3; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-transform: uppercase; letter-spacing: .1vh; }
#${ID} .plc-data { margin-top: 1.8vh; font-size: 2.6vh; color: rgba(255,255,255,.72); font-weight: 500; }
#${ID} .plc-selo { margin-top: 4vh; display: inline-flex; align-items: center; gap: 1.4vh; padding: 1.3vh 3.2vh; border-radius: 99px; font-size: 2.3vh; font-weight: 800; letter-spacing: .35vh; text-transform: uppercase;
  background: rgba(255,255,255,.08); border: .18vh solid rgba(245,215,142,.45); box-shadow: 0 0 4vh rgba(233,196,106,.18); }
#${ID} .plc-ponto { width: 1.4vh; height: 1.4vh; border-radius: 50%; background: #4ade80; box-shadow: 0 0 1.6vh #4ade80; animation: plcPulso 1.6s ease-in-out infinite; }
#${ID} .plc-chips { margin-top: 3.4vh; display: flex; gap: 1.6vh; justify-content: center; flex-wrap: wrap; }
#${ID} .plc-chip { padding: 1.4vh 2.6vh; border-radius: 1.6vh; background: rgba(255,255,255,.06); border: .15vh solid rgba(255,255,255,.12); min-width: 16vh; }
#${ID} .plc-chip b { display: block; font-size: 4.6vh; font-weight: 900; line-height: 1.05; }
#${ID} .plc-chip span { font-size: 1.7vh; font-weight: 700; letter-spacing: .25vh; text-transform: uppercase; color: rgba(255,255,255,.65); }
#${ID} .plc-prox { margin-top: 3.4vh; font-size: 2.4vh; color: rgba(255,255,255,.8); }
#${ID} .plc-prox b { color: #f5d78e; }
#${ID} .compacto .plc-brasao { height: 14vh; }
#${ID} .compacto .plc-grande { font-size: 9vh; }
#${ID} .compacto .plc-medio { font-size: 3.4vh; max-width: 70vw; }
#${ID} .compacto .plc-linha { margin: 2.4vh auto 2vh; }
#${ID} .compacto .plc-sessao { font-size: 2.6vh; }
#${ID} .plc-sobe { opacity: 0; animation: plcSobe 1s cubic-bezier(.2,.8,.2,1) forwards; }
#${ID} .d1 { animation-delay: .5s } #${ID} .d2 { animation-delay: .8s } #${ID} .d3 { animation-delay: 1.1s } #${ID} .d4 { animation-delay: 1.5s } #${ID} .d5 { animation-delay: 1.9s } #${ID} .d6 { animation-delay: 2.3s }
@keyframes plcSobe { from { opacity: 0; transform: translateY(3vh) } to { opacity: 1; transform: none } }
@keyframes plcBrasao { from { opacity: 0; transform: scale(.7) } to { opacity: 1; transform: none } }
@keyframes plcLinha { to { width: 38vh } }
@keyframes plcOuro { to { background-position: -200% 0 } }
@keyframes plcPulso { 0%,100% { opacity: 1 } 50% { opacity: .35 } }
@keyframes plcVarre { 0% { transform: translateX(-30%) } 55%,100% { transform: translateX(30%) } }
@keyframes plcFlutua { 0%,100% { transform: translate(0,0) } 50% { transform: translate(6vh,4vh) } }
`;

let timerFim = null;
function fechar(imediato) {
  const el = document.getElementById(ID);
  if (!el) return;
  clearTimeout(timerFim);
  if (imediato) { el.remove(); return; }
  el.classList.add('saindo');
  setTimeout(() => { if (el.parentNode) el.remove(); }, 1300);
}
function mostrar(html, duracao, classe, imediato) {
  fechar(true);
  if (!document.getElementById(ID + '-css')) {
    const st = document.createElement('style'); st.id = ID + '-css'; st.textContent = CSS; document.head.appendChild(st);
  }
  const el = document.createElement('div');
  el.id = ID;
  if (imediato) { el.className = 'on'; el.style.transition = 'none'; } // cobre a tela na hora (sem piscar a tela de baixo)
  el.innerHTML = `<div class="plc-orb a"></div><div class="plc-orb b"></div><div class="plc-brilho"></div><div class="plc-moldura"></div><div class="plc-conteudo ${classe || ''}">${html}</div>`;
  el.addEventListener('click', () => fechar(false));
  document.body.appendChild(el);
  if (imediato) requestAnimationFrame(() => requestAnimationFrame(() => { el.style.transition = ''; }));
  else requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('on')));
  timerFim = setTimeout(() => fechar(false), duracao);
}

function brasaoHtml(logo) {
  return logo ? `<img class="plc-brasao" src="${esc(logo)}" alt="">` : '';
}

export function mostrarAbertura({ camara, sessao }) {
  const nome = (camara && camara.nome) || 'Câmara Municipal';
  mostrar(`
    ${brasaoHtml(camara && camara.logoUrl)}
    <div class="plc-sobre plc-sobe d1">Poder Legislativo Municipal</div>
    <div class="plc-grande plc-sobe d2">${saudacao()}!</div>
    <div class="plc-medio plc-sobe d3">Sejam todos bem-vindos à ${esc(nome)}</div>
    <div class="plc-linha"></div>
    ${sessao && sessao.titulo ? `<div class="plc-sessao plc-sobe d4">${esc(tituloLimpo(sessao.titulo))}</div>` : ''}
    <div class="plc-data plc-sobe d5">${hoje()} · início às ${agoraHM()}</div>
    <div class="plc-selo plc-sobe d6"><span class="plc-ponto"></span>Sessão aberta</div>
  `, DURACAO_ABERTURA, '', true); // cobre a TV na hora: a tela de presenca nao aparece antes
}

export function mostrarEncerramento({ camara, sessao, proxima }) {
  const nome = (camara && camara.nome) || 'Câmara Municipal';
  const chips = ''; // PLENARIUM:AJUSTES_2110B -- o agradecimento nao mostra resumo de materias (so a mensagem, a data e a proxima sessao)
  mostrar(`
    ${brasaoHtml(camara && camara.logoUrl)}
    <div class="plc-sobre plc-sobe d1">Sessão encerrada</div>
    <div class="plc-grande plc-sobe d2">Muito obrigado!</div>
    <div class="plc-medio plc-sobe d3">A ${esc(nome)} agradece a presença e a participação de todos</div>
    <div class="plc-linha"></div>
    ${sessao && sessao.titulo ? `<div class="plc-sessao plc-sobe d4">${esc(tituloLimpo(sessao.titulo))}</div>` : ''}
    <div class="plc-data plc-sobe d4">${hoje()} · encerrada às ${agoraHM()}</div>
    ${chips}
    <div class="plc-prox plc-sobe d6" id="${ID}-prox">${proxima ? `Próxima sessão: <b>${esc(dataSessao(proxima.data))}</b>` : 'Até a próxima sessão.'}</div>
  `, DURACAO_ENCERRAMENTO, 'compacto', true);
}

async function buscarProxima(atualId) {
  try {
    const t = localStorage.getItem('token');
    const r = await axios.get('/api/sessoes', { headers: t ? { Authorization: `Bearer ${t}` } : {} });
    const agora = new Date();
    const offset = agora.getTimezoneOffset() * 60000; // data da sessao = horario local gravado como UTC
    const agoraLocalComoUTC = new Date(agora.getTime() - offset);
    return (Array.isArray(r.data) ? r.data : [])
      .filter(s => s.id !== atualId && s.status === 'AGENDADA' && new Date(s.data) > agoraLocalComoUTC)
      .sort((a, b) => new Date(a.data) - new Date(b.data))[0] || null;
  } catch (e) { return null; }
}

// Agradecimento na hora; a proxima sessao entra assim que chegar.
function encerrarAgora(camara, sessao) {
  mostrarEncerramento({ camara, sessao, proxima: null });
  buscarProxima(sessao && sessao.id).then(proxima => {
    const el = document.getElementById(ID + '-prox');
    if (el && proxima) el.innerHTML = `Próxima sessão: <b>${esc(dataSessao(proxima.data))}</b>`;
  });
}

// Usado pelo PainelTV: observa a sessao e dispara as telas nas mudancas.
// useLayoutEffect: roda antes de a tela ser pintada, entao o agradecimento
// cobre a TV no mesmo instante em que a sessao some (sem passar pela
// tela "Aguardando").
export function useCerimonialTV({ sessao, loading, camaraInfo }) {
  const ref = useRef({ pronto: false, id: null, ativa: false, foto: null });
  const camRef = useRef(camaraInfo);
  camRef.current = camaraInfo;
  useLayoutEffect(() => {
    if (loading) return;
    const st = ref.current;
    const ativa = !!(sessao && sessao.status === 'EM_ANDAMENTO');
    const camaraDe = (s) => ({ ...(camRef.current || {}), ...((s && s.camara) || {}) });
    if (!st.pronto) {
      st.pronto = true; st.id = sessao ? sessao.id : null; st.ativa = ativa; st.foto = ativa ? sessao : null;
      let teste = null; try { teste = new URLSearchParams(window.location.search).get('cerimonial'); } catch (e) { /* segue */ }
      if (teste === 'abertura') mostrarAbertura({ camara: camaraDe(sessao), sessao });
      if (teste === 'encerramento') encerrarAgora(camaraDe(sessao), sessao);
      return;
    }
    if (ativa && (!st.ativa || st.id !== sessao.id)) {
      mostrarAbertura({ camara: camaraDe(sessao), sessao });
    } else if (!ativa && st.ativa && st.foto) {
      encerrarAgora(camaraDe(st.foto), st.foto);
    }
    st.id = sessao ? sessao.id : null; st.ativa = ativa;
    if (ativa) st.foto = sessao;
  }, [loading, sessao]);
  useEffect(() => () => fechar(true), []);
}
